import React, {useState, useEffect, useContext, useRef} from "react";
import {useHistory} from "react-router-dom";
import classNames from "classnames";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Row,
  Col,
  Button,
} from "reactstrap";

import {
    Tooltip,
    OverlayTrigger
} from "react-bootstrap";

import ReactTable from "components/ReactTable/ReactTable.js";
import SweetAlert from "react-bootstrap-sweetalert";
import NotificationAlert from "react-notification-alert";
import rest from "../../API/api";
import { AthletesContext } from "../../context/AthletesContext";
import { UserLoginContext } from "../../context/UserLoginContext";
import { authenticatedFetch } from "../../services/authService";

const AthletesTable = () => {
    const [athletesState, setAthletesState] = useContext(AthletesContext);
    const [userState] = useContext(UserLoginContext);
    const [alert, setalert] = React.useState(null);
    const notificationAlertRef = useRef(null);
    const history = useHistory();
    const [dataLoaded, setDataLoaded] = useState(false);
    const [data, setData] = React.useState(
        (userState.status) ? (
            athletesState.theAthletes.map((theAthlete, i) => {
                return {
                    id: theAthlete._id,
                    firstName: theAthlete.firstName,
                    lastName: theAthlete.lastName,
                    email: theAthlete.email,
                    sport: theAthlete.sport,
                    teamName: theAthlete.teamName,
                    status: theAthlete.status,

                    actions: (
                        <div className="actions-right">
                            <OverlayTrigger placement="top"
                                            overlay={<Tooltip id={"add_" + i}>Add New Athlete</Tooltip>}>
                                <span>
                                <Button
                                    onClick={async () => {
                                        let tURL = "/admin/addathlete";
                                        await history.push(tURL);
                                    }}
                                    color="info"
                                    size="sm"
                                    className={classNames("btn-icon btn-link like",)}
                                >
                                    <i className="tim-icons icon-simple-add"/>
                                </Button>{" "}
                                </span>
                            </OverlayTrigger>
                            <OverlayTrigger placement="top" overlay={<Tooltip id={"edit_" + i}>Edit Athlete</Tooltip>}>
                                <span>
                                <Button
                                    onClick={async () => {
                                        setAthletesState((prevatheatesState) => ({
                                            ...prevatheatesState,
                                            theAthlete: theAthlete}));
                                        let tURL = "/admin/editathlete/";
                                        await history.push(tURL);
                                    }}
                                    color="warning"
                                    size="sm"
                                    className={classNames("btn-icon btn-link like",)}
                                >
                                    <i className="tim-icons icon-pencil"/>
                                </Button>{" "}
                                </span>
                            </OverlayTrigger>
                            <OverlayTrigger placement="top"
                                            overlay={<Tooltip id={"delete_" + i}>Delete Athlete</Tooltip>}>
                                <span>
                                <Button
                                    onClick={async () => {
                                        var theAthletes = data;
                                        theAthletes.find((o, i) => {
                                            if (o.id === theAthlete._id) {
                                                _deleteAthleteAlert(o.id, theAthletes, i);
                                                return true;
                                            }
                                            return false;
                                        });

                                    }}
                                    color="danger"
                                    size="sm"
                                    className={classNames("btn-icon btn-link like",)}
                                >
                                    <i className="tim-icons icon-simple-remove"/>
                                </Button>{" "}
                                </span>
                            </OverlayTrigger>

                        </div>
                    )
                };
            })
        ) : ({})
    );

    const notify = (type, message) => {
        const options = {
            place: "tc",
            message: <div>{message}</div>,
            type: type,
            icon: "tim-icons icon-bell-55",
            autoDismiss: 5,
        };
        notificationAlertRef.current.notificationAlert(options);
    };

    useEffect(() => {
        const getAthletes = async () => {
            const athletesList = await authenticatedFetch(rest.athletes, {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json;charset=UTF-8'
                })
            });
            const athletesData = await athletesList.json();
            setAthletesState((prevathletesState) => ({
                ...prevathletesState,
                theAthletes: athletesData
            }));
        };
        getAthletes();
    }, [dataLoaded]);

    const _delete_athlete = async (id) => {
        let tempURL = rest.athletes + '/' + id;
        const athletesList = authenticatedFetch(tempURL, {
            method: 'DELETE',
            headers: new Headers({
                'Content-Type': 'application/json;charset=UTF-8'
            })
        });
        const athletesResponse = await athletesList;
        const athletesData = await athletesResponse.json();
        return(athletesData);
    };

    const _deleteAthleteAlert = (id, theAthletes, i) => {
        setalert(
            <SweetAlert
                warning
                style={{display: "block", marginTop: "-100px"}}
                title="Are you sure?"
                onConfirm={async () => {
                    const athletesData = await _delete_athlete(id);
                    setAthletesState((prevathletesState) => ({
                        ...prevathletesState,
                        theAthletes: athletesData
                    }));
                    hideAlert();
                    notify("success", "Athlete has been deleted successfully!");
                    setDataLoaded(!dataLoaded);
                }}
                onCancel={() => hideAlert()}
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                confirmBtnText="Yes, delete it!"
                cancelBtnText="Cancel"
                showCancel
            >
                You will not be able to recover this athlete!
            </SweetAlert>
        );
    };

    const hideAlert = () => {
        setalert(null);
    };

    useEffect(() => {
        if (userState.status && athletesState.theAthletes) {
            const tempData = athletesState.theAthletes.map((theAthlete, i) => {
                return {
                    id: theAthlete._id,
                    firstName: theAthlete.firstName,
                    lastName: theAthlete.lastName,
                    email: theAthlete.email,
                    sport: theAthlete.sport,
                    teamName: theAthlete.teamName,
                    status: theAthlete.status,
                    actions: (
                        <div className="actions-right">
                            <OverlayTrigger placement="top"
                                            overlay={<Tooltip id={"add_" + i}>Add New Athlete</Tooltip>}>
                                <span>
                                <Button
                                    onClick={async () => {
                                        let tURL = "/admin/addathlete";
                                        await history.push(tURL);
                                    }}
                                    color="info"
                                    size="sm"
                                    className={classNames("btn-icon btn-link like",)}
                                >
                                    <i className="tim-icons icon-simple-add"/>
                                </Button>{" "}
                                </span>
                            </OverlayTrigger>
                            <OverlayTrigger placement="top" overlay={<Tooltip id={"edit_" + i}>Edit Athlete</Tooltip>}>
                                <span>
                                <Button
                                    onClick={async () => {
                                        setAthletesState((prevathletesState) => ({
                                            ...prevathletesState,
                                            theAthlete: theAthlete}));
                                        let tURL = "/admin/editathlete/";
                                        await history.push(tURL);
                                    }}
                                    color="warning"
                                    size="sm"
                                    className={classNames("btn-icon btn-link like",)}
                                >
                                    <i className="tim-icons icon-pencil"/>
                                </Button>{" "}
                                </span>
                            </OverlayTrigger>
                            <OverlayTrigger placement="top"
                                            overlay={<Tooltip id={"delete_" + i}>Delete Athlete</Tooltip>}>
                                <span>
                                <Button
                                    onClick={async () => {
                                        var theAthletes = data;
                                        theAthletes.find((o, i) => {
                                            if (o.id === theAthlete._id) {
                                                _deleteAthleteAlert(o.id, theAthletes, i);
                                                return true;
                                            }
                                            return false;
                                        });
                                    }}
                                    color="danger"
                                    size="sm"
                                    className={classNames("btn-icon btn-link like",)}
                                >
                                    <i className="tim-icons icon-simple-remove"/>
                                </Button>{" "}
                                </span>
                            </OverlayTrigger>
                        </div>
                    )
                };
            });
            setData(tempData);
        }
    }, [athletesState.theAthletes, userState.status]);

    return (
        <>
            <div className="rna-container">
                <NotificationAlert ref={notificationAlertRef} />
            </div>
            <div className="content">
                {alert}
                <Row>
                    <Col xs={12} md={12}>
                        <Card>
                            <CardHeader>
                                <Row>
                                    <Col md="6">
                                        <CardTitle tag="h4">Manage Athletes</CardTitle>
                                    </Col>
                                    <Col md="6" className="text-right">
                                        <Button
                                            color="info"
                                            onClick={() => history.push("/admin/addathlete")}
                                            className="animation-on-hover"
                                        >
                                            <i className="tim-icons icon-simple-add"/> Add Athlete
                                        </Button>
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody>
                                <ReactTable
                                    data={data}
                                    filterable
                                    resizable={false}
                                    columns={[
                                        {
                                            Header: "First Name",
                                            accessor: "firstName",
                                        },
                                        {
                                            Header: "Last Name",
                                            accessor: "lastName",
                                        },
                                        {
                                            Header: "Email",
                                            accessor: "email",
                                        },
                                        {
                                            Header: "Sport",
                                            accessor: "sport",
                                        },
                                        {
                                            Header: "Team",
                                            accessor: "teamName",
                                        },
                                        {
                                            Header: "Status",
                                            accessor: "status",
                                        },
                                        {
                                            Header: "Actions",
                                            accessor: "actions",
                                            sortable: false,
                                            filterable: false,
                                        },
                                    ]}
                                    defaultPageSize={10}
                                    showPaginationTop
                                    showPaginationBottom={false}
                                    className="-striped -highlight"
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    );
};

export default AthletesTable;
